import { energyClassColors, oldEnergyClassColors } from '../constants/energyClass';
import { EnergyClassCode, OldEnergyClassCode } from '../enums/EnergyClass';

const supportedEnergyClasses = [
  EnergyClassCode.A,
  EnergyClassCode.B,
  EnergyClassCode.C,
  EnergyClassCode.D,
  EnergyClassCode.E,
  EnergyClassCode.F,
  EnergyClassCode.G,
];

const supportedOldEnergyClasses = [
  OldEnergyClassCode.APlusPlusPlus,
  OldEnergyClassCode.APlusPlus,
  OldEnergyClassCode.APlus,
  OldEnergyClassCode.A,
  OldEnergyClassCode.B,
  OldEnergyClassCode.C,
  OldEnergyClassCode.D,
];

const isSupportedEnergyClassCode = (code: string) =>
  supportedEnergyClasses.includes(code as EnergyClassCode);

const isSupportedOldEnergyClassCode = (code: string) =>
  supportedOldEnergyClasses.includes(code as OldEnergyClassCode);

export const getEnergyClassMeta = (code: string): [string, string] => {
  if (!isSupportedEnergyClassCode(code)) {
    code = EnergyClassCode.G;
  }

  return [code, energyClassColors[code]];
};

export const getOldEnergyClassMeta = (code: string): [string, string] => {
  if (!isSupportedOldEnergyClassCode(code)) {
    code = OldEnergyClassCode.D;
  }

  return [code, oldEnergyClassColors[code]];
};
